import { useNavigate } from '@tanstack/react-router';
import { useState } from 'react';

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { ApiError } from '@/lib/api/client';
import { useCreateMcpConnection } from '@/lib/api/mcp-connections';
import { ConnectionForm } from '@/routes/mcp/connection-form';

export function McpConnectionNewPage() {
  const createConnection = useCreateMcpConnection();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">New MCP connection</h1>
        <p className="text-sm text-[var(--color-muted-foreground)]">
          One remote MCP server our client connects to, over Streamable HTTP.
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Connection</CardTitle>
          <CardDescription>The id is immutable once created — it's the ref prefix.</CardDescription>
        </CardHeader>
        <CardContent>
          <ConnectionForm
            submitting={createConnection.isPending}
            submitLabel="Create connection"
            error={error}
            onCancel={() => void navigate({ to: '/mcp/connections' })}
            onSubmit={(input) => {
              setError(null);
              createConnection.mutate(input, {
                onSuccess: () => void navigate({ to: '/mcp/connections' }),
                onError: (caught) =>
                  setError(
                    caught instanceof ApiError
                      ? caught.message
                      : 'Could not create the connection.',
                  ),
              });
            }}
          />
        </CardContent>
      </Card>
    </div>
  );
}
